import { roundNumber } from '@/utils/maths';
import clsx from 'clsx';
import { useState } from 'react';
import styles from '../style.module.css';
import { Activity } from '../types';
import { getIsRace } from '../utils/activities';
import { getDate, getDuration, getTime } from '../utils/date';
import { sports } from '../utils/enum';
import ActivityModal from './ActivityModal';
import PathDisplay from './PathDisplay';

type Props = {
  activity: Activity;
};

const ActivityCard = (props: Props) => {
  const { activity } = props;
  const {
    name,
    id,
    distance,
    moving_time,
    map,
    start_date,
    sport_type,
    workout_type,
  } = activity;
  const { hours, minuts, seconds } = getDuration(moving_time);
  const date = new Date(start_date); // Date fait la conversion
  const startDay = getDate.format(date);
  const starTime = getTime.format(date);
  const isRace = getIsRace(workout_type);
  const [ishovered, setIsHovered] = useState(false);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const polyline = map?.summary_polyline;

  const chrono = `${hours}:${minuts}:${seconds}`;
  const formattedDate = `${startDay} - ${starTime}`;

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <>
      <div
        role="gridcell"
        className={clsx(styles.activityCard, styles[sport_type.toLowerCase()], {
          [styles.checkerboard]: isRace,
        })}
        data-date={startDay}
        data-testid="cell"
        onClick={handleOpen}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <h5 className={styles.title}>
          <a href={`https://www.strava.com/activities/${id}`}>
            {sports[sport_type as keyof typeof sports]} {name}
          </a>
        </h5>
        <div
          className={clsx(
            styles.info,
            styles[sport_type.toLowerCase() + 'Info']
          )}
        >
          <span className={styles.date}>{formattedDate}</span>
          <div>
            <span>{`${roundNumber(distance / 1000)} km`}</span>
            <span>{chrono}</span>
          </div>
        </div>
        {ishovered && (
          <PathDisplay
            polyline={polyline}
            className={styles.pathOverlay}
            color="white"
          />
        )}
      </div>
      {open && (
        <ActivityModal
          open={open}
          handleClose={handleClose}
          handleOpen={handleOpen}
          polyline={polyline}
          activity={activity}
          chrono={chrono}
          date={formattedDate}
        />
      )}
    </>
  );
};

export default ActivityCard;
